export const LEGACY_REPOSITORIO_FLUJO_CAJA_MODULE_ID = 'repositorio_flujo_caja'
export const REPOSITORIO_FLUJO_CAJA_MENSUAL_MODULE_ID = 'repositorio_flujo_caja_mensual'
export const REPOSITORIO_FLUJO_CAJA_QUINCENAL_MODULE_ID = 'repositorio_flujo_caja_quincenal'
export const REPOSITORIO_FLUJO_CAJA_SEMANAL_MODULE_ID = 'repositorio_flujo_caja_semanal'

export const REPOSITORIO_FLUJO_CAJA_MODULE_IDS = [
  REPOSITORIO_FLUJO_CAJA_MENSUAL_MODULE_ID,
  REPOSITORIO_FLUJO_CAJA_QUINCENAL_MODULE_ID,
  REPOSITORIO_FLUJO_CAJA_SEMANAL_MODULE_ID,
]

export function isRepositorioFlujoCajaModuleId(moduleId) {
  return REPOSITORIO_FLUJO_CAJA_MODULE_IDS.includes(moduleId)
}

export { defaultConfiguracionEquipoAccess as defaultRepositorioFlujoCajaAccess } from './configuracionEquipoModule'

/** Empresa: sin fila → deshabilitado. Legacy solo aplica a mensual. */
export function defaultRepositorioFlujoCajaCompanyAccess(existingPerm, allPerms, moduleId) {
  if (existingPerm?.hasAccess === true) return true
  if (existingPerm?.hasAccess === false) return false
  if (
    moduleId === REPOSITORIO_FLUJO_CAJA_MENSUAL_MODULE_ID &&
    Array.isArray(allPerms)
  ) {
    const legacy = allPerms.find((p) => p.moduleId === LEGACY_REPOSITORIO_FLUJO_CAJA_MODULE_ID)
    return legacy?.hasAccess === true
  }
  return false
}

/**
 * Admin usuario: sin fila explícita → OFF (no mostrar staff default como grant).
 * Runtime (app) sigue usando staff + empresa.
 */
export function defaultRepositorioFlujoCajaUserAdminAccess(existingPerm) {
  if (existingPerm?.hasAccess === true) return true
  if (existingPerm?.hasAccess === false) return false
  return false
}
